import * as React from 'react';

export default {
  trialPeriod: 45,
  trialPeriodImageWording: ['Locally owned'],
  trialPeriodWording: ['Experience better hearing.'],
  subHeading: 'Best of the Springs, five years running!',
  appointmentTextBulletPoints: [
    'Come in for a comprehensive hearing evaluation.',
    'Pick the hearing aids that fit your lifestyle.',
    'We custom program the devices to your specific loss.',
  ],
  fiveStarReviews: [
    'They met my small budget.',
    'I understand why reviews are so positive.',
    'The staff here is amazing.',
    "I wouldn't go anywhere else.",
  ],
  warrantyPeriodYrs: 3,
  practionerFirstName: 'Mike',
  medicalBillingSpecialistName: 'Carol',
  medicalBillingSpecialistTitle: 'Insurance Coordinator',
  ownerInfo: 'Owners Carol & Dr. Kurt F. Smith',
  reviewIds: [
    '003e65fb-1977-5e6b-b7e9-7accf0e9e228',
    'f1f1059e-cf6a-5725-b305-50c0fc1fc007',
    'd8537b77-c60f-5523-89a9-02b46318b1c3',
    'e64f0282-2e0c-5fa9-bacb-fef73381ee46',
    'eb249f7b-2a08-5ef7-b918-c40c8c7c3d49',
  ],
  locationHeading: 'Visit us at one of our locations.',
  financingRate: 0,
};
